import { getEntityData } from "@/api/endpoints/entityData";
import type { GetEntityDataResponse } from "@/api/types/entityData";
import { queryKeys } from "@/lib/queryClient";
import type { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

export function useGetEntityData(
  sessionId: string | null | undefined,
  config?: Omit<
    UseQueryOptions<GetEntityDataResponse, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<GetEntityDataResponse, Error> {
  return useQuery({
    queryKey: queryKeys.entityData.bySession(sessionId || ""),
    queryFn: () => getEntityData(sessionId!),
    enabled: !!sessionId, // Only run query if sessionId exists
    ...config,
  });
}
